import { render } from "./Glossary.vue?vue&type=template&id=5fde239a&scoped=true&bindings={\"msg\":\"props\"}"
import script from "./Glossary.vue?vue&type=script&lang=js"
export * from "./Glossary.vue?vue&type=script&lang=js"

import "./Glossary.vue?vue&type=style&index=0&id=5fde239a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5fde239a"

export default script